import React, { useState, useCallback, useEffect, useRef } from 'react';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import 'react-datepicker/dist/react-datepicker.css';
//api
import {
  getDetailBlogCategory,
  editBlogCategory,
  deleteBlogCategory
} from 'api/blog';
//components
import Title from 'components/backoffice/texts/title';
import CategoryForm from 'components/backoffice/forms/categoryForm';

const EditBlogCategory = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [category, setCategory] = useState({});
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [validateName, setValidateName] = useState('');
  const { t } = useTranslation(['backoffice']);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const { setTitle } = useOutletContext()


  const detailBlogCategory = async () => {
    try {
      const { data, status } = await getDetailBlogCategory(id);
      if (status === 200) {
        setCategory(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    detailBlogCategory();
  }, []);

  useEffect(() => {
    if (category) {
      setTitle(t('edit', { title: category?.name }))
    }
    return () => {
      setTitle('');
    };
  }, [category])

  const onSubmit = useCallback(async (values) => {
    setLoading(true)
    const data = {
      name: values.name,
      image: values.image,
    };
    try {
      const response = await editBlogCategory(id, data);
      if (response.status === 200) {
        toast.success(t('editadocorrectamente'));
        navigate('/intranet/blog-categories', { replace: true });
      } else if (response.status === 400) {
        setValidateName(response.data.name[0])
      } else {
        toast.error(`${t('error')} ${response.data}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false)
  }, []);

  const handleDelete = useCallback(async () => {
    try {
      const { status } = await deleteBlogCategory(id);
      if (status === 204) {
        toast.success(t('eliminadocorrectamente'));
        navigate('/intranet/blog-categories', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
  }, [openModalDelete]);

  return (
    <div className="mt-5">
      <Title text={t('editblogcategory')} />
      <CategoryForm
        loading={loading}
        isEditing={true}
        onSubmitForm={onSubmit}
        openModalDelete={openModalDelete}
        setOpenModalDelete={setOpenModalDelete}
        defaultValues={category}
        onDelete={handleDelete}
        id={id}
        fileInputRef={fileInputRef}
        validateName={validateName}
        setValidateName={setValidateName}
      />
    </div>
  );
};

export default EditBlogCategory;
